import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Stack, Box, Button } from "@mui/material";

const OverrideQualificationDialog = ({ trigger }) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			{/* Trigger */}
			<span onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
				{trigger}
			</span>

			{/* Dialog */}
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				PaperProps={{
					sx: {
						width: "360px !important",
						maxWidth: "360px !important",
					},
				}}
			>
				<DialogTitle
					sx={{
						fontSize: "1.7rem !important",
						color: "#1D54A2",
					}}
				>
					Override Qualification
				</DialogTitle>

				<DialogContent>
					<Stack spacing={2} sx={{ mt: 1 }}>
						<Typography fontSize={13} color="#444">
							Whether agent qualifies for overrides.
						</Typography>

						<Box
							sx={{
								background: "#F4F6FA",
								borderRadius: "8px",
								p: "18px !important",
							}}
						>
							<Typography fontWeight={700} fontSize={13.5} mb={1}>
								Qualification Rules
							</Typography>

							<Box component="ul" sx={{ pl: 2, mt: 1, mb: 0 }}>
								<li>
									<strong>25</strong> personal <strong>active</strong> members OR <strong>100</strong> total{" "}
									<strong>network</strong> members
								</li>
								<li>
									<strong>Active</strong> insurance license
								</li>
								<li>
									<strong>Active</strong> status with Ally
								</li>
							</Box>
						</Box>

						<Box sx={{ textAlign: "right", mt: 2 }}>
							<Button
								onClick={() => setOpen(false)}
								variant="contained"
								sx={{
									backgroundColor: "#1D54A2",
									textTransform: "none",
									"&:hover": {
										backgroundColor: "#174a91",
									},
								}}
							>
								Close
							</Button>
						</Box>
					</Stack>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default OverrideQualificationDialog;
